import { TransactionHistoryDto } from '../../../dto/transactionhistory/transactionhistorydto';
import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface TransactionHistoryResponse extends APIResponse
{
    getTransactionHistoryDtos(): TransactionHistoryDto[];
}

export class TransactionHistoryResponseDtoImpl extends APIResponseDtoImpl implements TransactionHistoryResponse
{
    private transactionHistoryDtos : TransactionHistoryDto[];

    getTransactionHistoryDtos(): TransactionHistoryDto[]
    {
        return this.transactionHistoryDtos;
    }
    setTransactionHistoryDtos(transactionHistoryDtos: TransactionHistoryDto[])
    {
        this.transactionHistoryDtos = transactionHistoryDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/transactionhistory/transactionhistoryresponse.tsx